import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { searchConsumerHistory } from '../../../api/consumerHistory'


export const fetchConsumerHistory = createAsyncThunk('consumer/searchConsumerHistory', async (params) => {
    const response = await searchConsumerHistory(params)
    console.log("searchConsumerHistory response --> ", response.data )
    return response.data
})

export const consumerHistorySlice = createSlice({
    name : "consumer/searchConsumerHistory",
    initialState : {
        loading: false,
        consumerOrders: [],
        materialDetails: [],
        createdUserDetails: [],
        paginationParams: {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true
        },
        searchParams: {
            dataType: "consumerOrder",
            searchBy: "all",
            searchText: "",
            statusId: 1,
            dateType: "createdAt"
        },
        searchOptions: []
    },
    reducers: {
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
        }
    },
    extraReducers : (builder) => {
        builder.addCase(
            fetchConsumerHistory.fulfilled, (state, action) => {
                state.loading = false 
                state.consumerOrders = action.payload.data
                state.materialDetails = action.payload.materialDetails
                state.createdUserDetails = action.payload.createdUserDetails
                state.paginationParams.pageNo = action.payload.pageNo - 1
                state.paginationParams.recordsPerPage = action.payload.recordsPerPage 
                if(action.payload.totalRecords || action.payload.totalRecords === 0){
                    state.paginationParams.totalRecords = action.payload.totalRecords
                }
            }
        )
        .addCase(
            fetchConsumerHistory.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchConsumerHistory.rejected, (state, action) => {
                state.loading = false
            }
        )
    }

})

export const { updateSearchParams, updateSearchOptions } = consumerHistorySlice.actions

export default consumerHistorySlice.reducer